import { useMemo, useState, useCallback } from 'react';

import { type PageMetaDto, DEFAULT_PAGE_SIZE } from 'src/types/pagination';

export const useSSRPaginatedInfiniteScrolling = (initialPageSize: number = DEFAULT_PAGE_SIZE) => {
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(initialPageSize);
  const [total, setTotal] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [paginatedData, setPaginatedData] = useState<Map<number, any>>(new Map());
  const [resetNonce, setResetNonce] = useState(0);

  const data = useMemo(
    () => Array.from(paginatedData.values()).flatMap((e) => e ?? []),
    [paginatedData]
  );
  const currentPage = useMemo(() => page, [page]);

  return {
    onPageLoaded: useCallback((responseData: any, meta: PageMetaDto) => {
      setPaginatedData((prev) => {
        if (meta.page === 1) {
          return new Map([[1, responseData ?? []]]);
        }
        const newMap = new Map(prev);
        newMap.set(meta.page, responseData ?? []);
        return newMap;
      });
      setTotal(meta.itemCount);
      setTotalPages(meta.pageCount);
      // setPage(meta.page);
    }, []),
    onPageSizeChange: (size: number) => {
      setPageSize(size);
      setPage(0);
    },
    onPageChange: useCallback((newPage: number) => {
      setPage(newPage);
    }, []),
    onReset: useCallback(() => {
      setPaginatedData(new Map());
      setPage(0);
      setTotal(0);
      setTotalPages(0);
      setResetNonce((nonce) => nonce + 1);
    }, []),
    resetNonce,
    total,
    page: currentPage,
    pageSize,
    data,
    totalPages,
  };
};
